// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2MgFt","footerBox":"Footer_footerBox___dMO6"};